import React from "react";
import { Plus, Minus, Dices } from "lucide-react";
import { STAT_MIN, STAT_MAX } from "@/lib/character";

export default function StatBlock({ label, abbr, value, onChange, onRoll, rollHint, accent = "yellow", testKey }) {
  const cls = accent === "magenta" ? "panel-magenta" : accent === "cyan" ? "panel-cyan" : "panel-yellow";
  const clamped = (v) => Math.max(STAT_MIN, Math.min(STAT_MAX, v));
  return (
    <div className={`panel ${cls} p-3 sm:p-4 flex flex-col items-stretch gap-2 relative`}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-mono uppercase tracking-widest text-[color:var(--text-secondary)]">{abbr}</span>
        <span className="font-display text-[10px] uppercase tracking-widest text-[color:var(--text-muted)]">{label}</span>
      </div>
      <div className="flex items-center justify-between gap-2">
        <button
          aria-label={`Decrease ${label}`}
          data-testid={`stat-${testKey}-dec`}
          onClick={() => onChange(clamped((value || 0) - 1))}
          className="w-9 h-9 border-2 border-[color:var(--border-hard)] hover:bg-[color:var(--accent-magenta)] hover:text-[color:var(--bg-void)] flex items-center justify-center"
        >
          <Minus size={16} />
        </button>
        <div data-testid={`stat-${testKey}-value`} className="font-display text-4xl sm:text-5xl font-black tabular-nums text-[color:var(--accent-yellow)] leading-none min-w-[3ch] text-center">
          {(value || 0) >= 0 ? "+" : ""}{value || 0}
        </div>
        <button
          aria-label={`Increase ${label}`}
          data-testid={`stat-${testKey}-inc`}
          onClick={() => onChange(clamped((value || 0) + 1))}
          className="w-9 h-9 border-2 border-[color:var(--border-hard)] hover:bg-[color:var(--accent-cyan)] hover:text-[color:var(--bg-void)] flex items-center justify-center"
        >
          <Plus size={16} />
        </button>
      </div>
      {onRoll && (
        <button
          aria-label={`Roll ${label}`}
          data-testid={`stat-${testKey}-roll`}
          onClick={onRoll}
          className="cy-btn text-[10px] py-1 min-h-0 mt-1"
          title={rollHint || "Roll to generate this stat"}
        >
          <Dices size={12} className="mr-1" /> ROLL
        </button>
      )}
      {rollHint && (
        <div className="text-[9px] font-mono uppercase tracking-widest text-[color:var(--text-muted)] text-center">
          {rollHint}
        </div>
      )}
    </div>
  );
}
